function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 1.70398L8.45401 11.25C6.48755 13.2161 5.1762 15.7415 4.6992 18.481C4.2222 21.2205 4.60281 24.0405 5.78901 26.5556C6.97522 29.0706 8.90915 31.158 11.3265 32.5325C13.7438 33.9069 16.5266 34.5013 19.2945 34.2345C21.8426 33.9892 24.2684 33.0244 26.2891 31.4528C28.3097 29.8812 29.8418 27.7674 30.7068 25.3581C31.5717 22.9488 31.7338 20.3432 31.1742 17.8453C30.6146 15.3473 29.3562 13.06 27.546 11.25L18 1.70398ZM10.575 13.371L18 5.94598V31.296C15.9232 31.2961 13.893 30.6804 12.1661 29.5267C10.4393 28.3729 9.09334 26.733 8.29856 24.8143C7.50377 22.8955 7.29584 20.7842 7.70105 18.7473C8.10625 16.7104 9.1064 14.8394 10.575 13.371Z",
  fill: "#F5F5F5"
});

function SvgInvert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvert);
export default __webpack_public_path__ + "static/media/Invert.a08e01eb.svg";
export { ForwardRef as ReactComponent };